import { ScriptDef } from "../parser/definition/types/ScriptDef";
import { StructureNodeDef } from "../parser/definition/types/StructureNodeDef";
import { convertMainDefToLegacyRoot } from "./convertMainDefToLegacyRoot";
import { convertNodeDefsToLegacyNodes } from "./convertNodeDefsToLegacyNodes";
import { Source } from "./types/Source";
import { SourceNodes } from "./types/SourceNodes";
import { getRootNodeName } from "./utils/getRootNodeName";


export function convertScriptDefToLegacy(
    scriptDef: ScriptDef,
): Source {
    let nodes: SourceNodes = {};
    nodes = convertNodeDefsToLegacyNodes(scriptDef.nodeDefs);
    nodes[getRootNodeName()] = convertMainDefToLegacyRoot(scriptDef.mainDef as StructureNodeDef<any, any, any>)

    return {
        version: "0.1.21",
        nodes,
        deployment: {}
    }
}